<template>
  <v-row>
    <v-col v-if="isloading" cols="12" class="justify-center d-flex">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" class="justify-center align-center d-flex">
      <v-chip-group column light>
        <template v-for="(item, index) in Balance">
          <v-chip small :color="colorName" outlined :key="index"
            ><strong
              >{{ item.AccountName }}:
              <span class="white--text">
                {{ item.Amount.toLocaleString() }}</span
              ></strong
            >
          </v-chip>
        </template>
      </v-chip-group>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    fromDate: [String],
    toDate: [String],
    Balance: { type: Array },
    isloading: { type: Boolean },
    colorName: { type: String, default: "indigo" },
  },
  // watch: {
  //   Balance(value) {
  //     console.log(value);
  //     let date = this.Current();
  //     console.log(date);
  //   }
  // },
  // methods: {
  //   EachExpense(Expense) {
  //     console.log(Expense);
  //   }
  // }
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
